export const supportEmail = "support@gtdiag.com";

export const BASE_URL = "https://study-configuration.demo.hipal-app.com";
